export enum RoleType {
    SA = 'SuperAdmin',

  }
  